export var FlyNavControlCommand = function(navCmd, navPanel){
	this.navCmd = navCmd;
	this.navPanel = navPanel;
}
FlyNavControlCommand.prototype = {
	constructor : FlyNavControlCommand,
	exec : function(scope){
		if (this.navCmd === 0){
			if(scope.sceneManager.roadNav.airMode==2){
				scope.flyTips();
				return
			}
			scope.sceneManager.roadNav.stop();
			this.navPanel.player = 'play';
			// this.navPanel.playIcon = '/static/bimroad/imgs/player_play.png'

		}
		else if (this.navCmd === 1){
			if (scope.sceneManager.roadNav.state == 0){
				scope.sceneManager.roadNav.initAirMode();
				scope.sceneManager.roadNav.start(this.navPanel.flySpeed);	
				this.navPanel.player = 'pause';
			}
			else if (scope.sceneManager.roadNav.state == 1){
				if(scope.sceneManager.roadNav.airMode==2){
					scope.flyTips();
					return
				}
				scope.sceneManager.roadNav.pause();	
				this.navPanel.player = 'play';
			}
			else{
				if(scope.sceneManager.roadNav.airMode==2){
					scope.flyTips();
					return
				}
				scope.sceneManager.roadNav.resume();
				this.navPanel.player = 'pause'
			}
			

		}
		else if (this.navCmd ===2){
			if(scope.sceneManager.roadNav.airMode==2){
				scope.flyTips();
				return
			}
			scope.sceneManager.roadNav.incSpeed();
			this.navPanel.flySpeed = scope.sceneManager.roadNav.getSpeed();
		}
		else if (this.navCmd ===3){
			if(scope.sceneManager.roadNav.airMode==2){
				scope.flyTips();
				return
			}
			scope.sceneManager.roadNav.decSpeed();
			this.navPanel.flySpeed = scope.sceneManager.roadNav.getSpeed();
		}
		else if (this.navCmd === -1){
			this.navPanel.showSelf = true;
		}
		else if (this.navCmd === 4){
			if(scope.sceneManager.roadNav.airMode==2){
				scope.flyTips();
				return
			}
			scope.sceneManager.roadNav.incHeight();
			this.navPanel.flyHeight = scope.sceneManager.roadNav.getHeight();
		}
		else if (this.navCmd === 5){
			if(scope.sceneManager.roadNav.airMode==2){
				scope.flyTips();
				return
			}
			scope.sceneManager.roadNav.decHeight();
			this.navPanel.flyHeight = scope.sceneManager.roadNav.getHeight();
		}
	}
}


// WEBPACK FOOTER //
// ./src/plugins/components/Web3dModels/commands/FlyNavControlCommand.js